import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { OfferSection } from './components/OfferSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2433320707143614');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2433320707143614&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-pageBg text-body font-sans" data-id="element-0">
      {/* Urgency Bar */}
      <div className="bg-cardBorder text-accent text-center py-3 px-5 font-semibold text-[0.95rem] tracking-[0.5px] border-b border-cardBorder" data-id="element-1">
        📥 Descarga inmediata · Sin esperas · Acceso al instante
      </div>

      {/* Sticky Nav */}
      <nav className="bg-deepPurple py-[18px] px-6 md:px-10 flex justify-between items-center sticky top-0 z-[100] shadow-md" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/cYknYAv4px6H22WJwF3nuP/INK_1_PNG.png" alt="Inkova" className="h-8 md:h-10 brightness-0 invert" data-id="element-3" />
        <a href="#cta" className="text-white border-none py-2 px-4 md:py-3 md:px-7 rounded-full font-bold text-[0.8rem] md:text-[0.95rem] cursor-pointer no-underline transition-all shadow-md hover:shadow-lg hover:-translate-y-[1px]" style={{
        background: 'linear-gradient(to right, #D946A8, #C026D3)'
      }} data-id="element-4">
          Descargar Guía $27.99
        </a>
      </nav>

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <AboutSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>

      {/* Footer */}
      <footer className="bg-deepPurple text-white text-center p-10 text-[0.9rem] border-t border-deepPurple" data-id="element-13">
        <p className="mb-2" data-id="element-14">
          © {new Date().getFullYear()} Inkova LLC ·{' '}
          <a href="https://go.inkovacreation.com" className="text-white no-underline hover:underline" data-id="element-15">
            go.inkovacreation.com
          </a>
        </p>
        <p data-id="element-16">
          <a href="#" className="text-white no-underline hover:underline" data-id="element-17">
            Política de Privacidad
          </a>{' '}
          ·{' '}
          <a href="#" className="text-white no-underline hover:underline" data-id="element-18">
            Términos de Uso
          </a>
        </p>
      </footer>
    </div>;
}